export default function formatStringToValue(string) {
  if(!string) {
    return undefined;
  }

  else if(string === 'true') {
    return true;
  }

  else if(string === 'false') {
    return false;
  }

  else if(string === 'null') {
    return null;
  }

  else if(string === 'undefined') {
    return undefined;
  }

  else {
    return string;
  }
}

